import { makeAutoObservable, runInAction } from 'mobx';
import { getUserRolesRequest, loginUser } from 'services/requestAgent';
import { getCachedRoles, KEY_ROLES, processRolesArray } from 'services/roles';

class AuthStore {
  isLoading = false;
  isLoginSuccess = false;
  userRoles = [];
  operatorRoles = [];
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  resetStore = () => {
    this.isLoading = false;
    this.isLoginSuccess = false;
    this.userRoles = [];
    this.operatorRoles = [];
    this.error = null;
  };

  setIsLoading = (status) => {
    this.isLoading = status;
    this.error = null;
  };

  sendAuthorizationData = async (data) => {
    this.setIsLoading(true);
    try {
      await loginUser(data);

      runInAction(() => {
        this.isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
        this.error = err;
      });
    }
  };

  getUserRoles = async (force = false) => {
    this.setIsLoading(true);
    try {
      const rolesFromCache = getCachedRoles();
      let roles = [];

      if (!rolesFromCache || force) {
        const response = await getUserRolesRequest();
        roles = Object.values(response).map(({ authority }) => authority);
        localStorage.setItem(KEY_ROLES, roles.join(','));
      }
      processRolesArray(roles?.length > 0 ? roles : rolesFromCache);

      runInAction(() => {
        this.userRoles = roles?.length > 0 ? roles : rolesFromCache;
        this.operatorRoles = this.userRoles.filter(
          (role) => role === 'ROLE_SALES' || role === 'ROLE_ADMIN' || role === 'ROLE_SUPPORT'
        );
        this.isLoginSuccess = true;
        this.isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.isLoading = false;
        this.error = err;
      });
    }
  };

  getOperatorRoles = () => {
    // If operatorRoles is not populated yet, filter from cached roles
    if (this.operatorRoles.length === 0) {
      const cachedRoles = getCachedRoles();
      return cachedRoles.filter((role) => role === 'ROLE_SALES' || role === 'ROLE_ADMIN' || role === 'ROLE_SUPPORT');
    }
    return this.operatorRoles;
  };

  hasSalesRole = () => {
    // If operatorRoles is not populated yet, check from cached roles
    if (this.operatorRoles.length === 0) {
      const cachedRoles = getCachedRoles();
      return cachedRoles.includes('ROLE_SALES');
    }
    return this.operatorRoles.includes('ROLE_SALES');
  };
}

export default new AuthStore();
